import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import AsyncSelect from "common/components/AsyncSelect/AsyncSelect";
import TabPanelComponent from "common/components/TabPanel/TabPanelComponent";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { VISIBILITY } from "utils/constants";

const DialogContentCreate = ({ activityFormData, setActivityFormData, editableMode = false }) => {
    const { auth } = useAuth();
    const [datasets, setDatasets] = useState([]);
    const [actualDataset, setActualDataset] = useState();
    const [actualDynamicDataSource, setActualDynamicDataSource] = useState();

    const [visibility, setVisibility] = React.useState(
        activityFormData.visibility || VISIBILITY.public
    );
    const [visibilityDataset, setVisibilityDataset] = React.useState(VISIBILITY.public);
    const [valueTab, setValueTab] = useState("staticDataSource");
    const [dynamicDataSourceList, setDynamicDataSoruceList] = useState([]);
    const initialDataGraphBase = {
        dataTable: false,
        column: false,
        line: false,
        pie: false,
        bubble: false,
        dispersion: false,
        map: false,
        static_network: false,
        word_cloud: false,
    };

    const [initialDataGraph, setInitialDataGraph] = useState({
        ...initialDataGraphBase,
    });

    const [graphs, setGraphs] = useState(initialDataGraph);

    const initialDataGraphDynamic = {
        social_user_comments: true,
        social_word_frequency: true,
    };

    const [dynamicGraphs, setDynamicGraphs] = useState(initialDataGraphDynamic);

    useEffect(() => {
        if (editableMode && Object.keys(activityFormData.graphsData).length > 0) {
            setInitialDataGraph({
                ...initialDataGraph,
                ...activityFormData.graphsData,
            });
            setGraphs({
                ...initialDataGraph,
                ...activityFormData.graphsData,
            });

            if (activityFormData.staticDataSource) {
                setValueTab("staticDataSource");
            }

            if (activityFormData.dynamicDataSource) {
                setValueTab("dynamicDataSource");
            }

            setActualDataset(activityFormData.staticDataSource);
            setActualDynamicDataSource(activityFormData.dynamicDataSource);
        }
    }, []);

    const { bubble, column, line, pie, map, static_network, word_cloud } = graphs ?? {};

    const handleChange = (event) => {
        const newGraphs = {
            ...graphs,
            [event.target.name]: event.target.checked,
        };
        setGraphs(newGraphs);
        setActivityFormData({
            ...activityFormData,
            graphsData: newGraphs,
        });
    };

    const handleChangeVisibility = (event) => {
        setVisibility(event.target.value);
        setActivityFormData({
            ...activityFormData,
            visibility: event.target.value,
        });
    };

    const handleChangeVisibilityDataset = (event) => {
        setVisibilityDataset(event.target.value);
    };

    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
        if (!editableMode) {
            setActivityFormData({
                ...activityFormData,
                staticDataSource: null,
                dynamicDataSource: null,
                graphsData:
                    newValue === "dynamicDataSource" ? initialDataGraphDynamic : initialDataGraph,
                visibility: activityFormData.visibility || VISIBILITY.public,
            });

            setGraphs(initialDataGraph);
            setVisibilityDataset(VISIBILITY.public);
            setActualDataset(null);
            setDynamicGraphs(initialDataGraphDynamic);
        }
    };

    const getStaticDataSource = async (search, visibilityFilter) => {
        const res = await ApiService.getStaticDataSources(null, null, {
            no_page: 1,
            hide: false,
            visibility: visibilityFilter,
            establishment:
                auth.selectedRole?.name === "superadmin" ||
                visibilityFilter === VISIBILITY.community
                    ? null
                    : auth.selectedEstablishment?.id || null,
            search,
        });
        setDatasets(res.data);
    };

    const getDynamicDataSource = async (search, visibilityFilter) => {
        const res = await ApiService.getDynamicDataSources();
        setDynamicDataSoruceList(res.data);
    };

    const searchAsyncSelect = (search) => {
        if (search === "") {
            setDatasets([]);
            return [];
        }
        getStaticDataSource(search, visibilityDataset);
    };

    useEffect(() => {
        getDynamicDataSource();
    }, []);

    return (
        <>
            {/* <TextField
                fullWidth
                id="subject"
                select
                label="Curso"
                // value={activityFormData.course}
                onChange={(evt) => {
                    setActivityFormData({
                        ...activityFormData,
                        course: [...activityFormData.course, evt.target.value],
                    });
                }}
                margin="normal"
            >
                {courses.map((course) => (
                    <MenuItem key={course.id} value={course.id}>
                        {course.name}
                    </MenuItem>
                ))}
            </TextField> */}
            <FormControl fullWidth margin="normal">
                <TextField
                    required
                    autoFocus
                    margin="normal"
                    id="title"
                    fullWidth
                    label="Título de la actividad"
                    type="text"
                    value={activityFormData.title}
                    // variant="standard"
                    inputProps={{ maxLength: 100 }}
                    onChange={(evt) => {
                        setActivityFormData({
                            ...activityFormData,
                            title: evt.target.value,
                        });
                        // setEmailError(false);
                    }}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                    {`${activityFormData.title.length} / 100`}
                </FormHelperText>
            </FormControl>
            <h5>Enunciado</h5>
            <Grid
                container
                sx={{
                    display: "flex",
                    justifyContent: "right",
                }}
            >
                <Grid item xs={11}>
                    <FormControl fullWidth margin="normal">
                        <TextField
                            required
                            margin="normal"
                            id="statementTitle"
                            fullWidth
                            label="Título del enunciado"
                            type="text"
                            value={activityFormData.statementTitle}
                            inputProps={{ maxLength: 100 }}
                            onChange={(evt) => {
                                setActivityFormData({
                                    ...activityFormData,
                                    statementTitle: evt.target.value,
                                });
                                // setEmailError(false);
                            }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${activityFormData.statementTitle.length} / 100`}
                        </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <TextField
                            required
                            id="statement"
                            label="Enunciado"
                            InputLabelProps={{ shrink: true }}
                            placeholder="Incluya aquí la consigna o tarea que debe realizar el estudiante"
                            type="text"
                            multiline
                            rows={4}
                            maxRows={6}
                            value={activityFormData.statement}
                            inputProps={{ maxLength: 1000 }}
                            onChange={(evt) => {
                                setActivityFormData({
                                    ...activityFormData,
                                    statement: evt.target.value,
                                });
                            }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${activityFormData.statement.length} / 1000`}
                        </FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
            <FormControl>
                <FormLabel id="visilibty">Visibilidad actividad</FormLabel>
                <RadioGroup
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={visibility}
                    onChange={handleChangeVisibility}
                >
                    <FormControlLabel
                        value={VISIBILITY.public}
                        control={<Radio />}
                        label="Establecimiento"
                    />
                    <FormControlLabel
                        value={VISIBILITY.private}
                        control={<Radio />}
                        label="Privado"
                    />
                    <FormControlLabel
                        value={VISIBILITY.community}
                        control={<Radio />}
                        label="Comunidad"
                    />
                </RadioGroup>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <TextField
                    // error={emailError}
                    required
                    margin="normal"
                    id="objetive"
                    fullWidth
                    label="Objetivo de la actividad"
                    type="text"
                    // variant="standard"
                    inputProps={{ maxLength: 1000 }}
                    value={activityFormData.objetive}
                    multiline
                    rows={4}
                    maxRows={6}
                    onChange={(evt) => {
                        setActivityFormData({
                            ...activityFormData,
                            objetive: evt.target.value,
                        });
                        // setEmailError(false);
                    }}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                    {`${activityFormData.objetive.length} / 1000`}
                </FormHelperText>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <TextField
                    // error={emailError}
                    required
                    margin="normal"
                    id="description"
                    fullWidth
                    label="Descripción de la actividad"
                    type="text"
                    multiline
                    rows={5}
                    maxRows={6}
                    InputLabelProps={{ shrink: true }}
                    placeholder={
                        "Incluya aquí la descripción de la actividad, por ejemplo, el contexto de la actividad (el tema que se aborda y porqué), que se espera que aprenda o desarrolle el estudiante, si es una tarea grupal o individual, cómo se relaciona con los contenidos que se trabajaron previamente y cuáles son los criterios de evaluación"
                    }
                    // variant="standard"
                    inputProps={{ maxLength: 1000 }}
                    value={activityFormData.description}
                    onChange={(evt) => {
                        setActivityFormData({
                            ...activityFormData,
                            description: evt.target.value,
                        });
                        // setEmailError(false);
                    }}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                    {`${activityFormData.description.length} / 1000`}
                </FormHelperText>
            </FormControl>

            <div
                style={{
                    border: "1px solid #C0C0C0",
                    borderRadius: 2,
                    marginBottom: 15,
                    marginTop: 15,
                }}
            >
                <Tabs value={valueTab} onChange={handleChangeTab} aria-label="basic tabs example">
                    <Tab
                        disabled={editableMode && valueTab === "dynamicDataSource"}
                        label="Fuentes estáticas"
                        value="staticDataSource"
                    />
                    <Tab
                        disabled={editableMode && valueTab === "staticDataSource"}
                        label="Fuentes dinámicas"
                        value="dynamicDataSource"
                    />
                </Tabs>

                <TabPanelComponent value={valueTab} index={"staticDataSource"}>
                    <div
                        style={{
                            padding: "12px 18px",
                        }}
                    >
                        <FormControl>
                            <Typography style={{ color: "#787E8F" }}>
                                Filtro visibilidad dataset
                            </Typography>
                            <RadioGroup
                                row
                                required
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={visibilityDataset}
                                onChange={handleChangeVisibilityDataset}
                            >
                                <FormControlLabel
                                    value={VISIBILITY.public}
                                    control={<Radio />}
                                    label="Establecimiento"
                                />
                                <FormControlLabel
                                    value={VISIBILITY.private}
                                    control={<Radio />}
                                    label="Privado"
                                />
                                <FormControlLabel
                                    value={VISIBILITY.community}
                                    control={<Radio />}
                                    label="Comunidad"
                                />
                            </RadioGroup>
                        </FormControl>
                        <AsyncSelect
                            required
                            options={datasets}
                            defaultValue={actualDataset}
                            onChangeSearch={async (search) => {
                                searchAsyncSelect(search);
                            }}
                            onChangeSelect={(value) => {
                                setGraphs(initialDataGraphBase);
                                setActualDataset(value);
                                setActivityFormData({
                                    ...activityFormData,
                                    staticDataSource: value,
                                    graphsData: initialDataGraphBase,
                                });
                            }}
                            label="Búsqueda dataset*"
                            onClose={() => {
                                setDatasets([]);
                            }}
                        />
                        <FormControl>
                            <FormLabel component="legend">Gráficos permitidos</FormLabel>
                            <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                                <FormControlLabel
                                    disabled={!(actualDataset?.name || "").includes("csv")}
                                    control={
                                        <Checkbox
                                            checked={column}
                                            onChange={handleChange}
                                            name="column"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Columnas agrupadas.png"
                                                    alt="Columnas agrupadas"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Columnas agrupadas</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={!(actualDataset?.name || "").includes("csv")}
                                    control={
                                        <Checkbox
                                            checked={line}
                                            onChange={handleChange}
                                            name="line"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Líneas agrupadas.png"
                                                    alt="Líneas agrupadas"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Líneas agrupadas</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={!(actualDataset?.name || "").includes("csv")}
                                    control={
                                        <Checkbox
                                            checked={pie}
                                            onChange={handleChange}
                                            name="pie"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Torta.png"
                                                    alt="Torta"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Torta</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={!(actualDataset?.name || "").includes("csv")}
                                    control={
                                        <Checkbox
                                            checked={bubble}
                                            onChange={handleChange}
                                            name="bubble"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Burbujas.png"
                                                    alt="Burbujas"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Burbujas</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={!(actualDataset?.name || "").includes("csv")}
                                    control={
                                        <Checkbox
                                            checked={map}
                                            onChange={handleChange}
                                            name="map"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Mapa.png"
                                                    alt="Mapa"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Mapa</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={!(actualDataset?.name || "").includes("csv")}
                                    control={
                                        <Checkbox
                                            checked={static_network}
                                            onChange={handleChange}
                                            name="static_network"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Grafo.png"
                                                    alt="Grafo"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Grafo</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={!(actualDataset?.name || "").includes("pdf")}
                                            checked={word_cloud}
                                            onChange={handleChange}
                                            name="word_cloud"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Nube de palabras.png"
                                                    alt="Nube de palabras"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Nube de palabras</p>
                                        </Tooltip>
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </div>
                </TabPanelComponent>

                <TabPanelComponent value={valueTab} index={"dynamicDataSource"}>
                    <div
                        style={{
                            padding: "12px 18px",
                        }}
                    >
                        <TextField
                            required
                            select
                            label="Seleccione una fuente dinámica"
                            fullWidth
                            defaultValue={actualDynamicDataSource}
                            onChange={(evt) => {
                                setActivityFormData({
                                    ...activityFormData,
                                    dynamicDataSource: evt.target.value,
                                });
                            }}
                        >
                            {dynamicDataSourceList.map((province) => (
                                <MenuItem key={province.id} value={province.id}>
                                    {province.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                </TabPanelComponent>
            </div>
        </>
    );
};

export default DialogContentCreate;
